import httpClient from "../../../client/httpClient";

export const fetchAllProducts = async ({ sellerId, filters, pagination }, signal) => {
    const body = {
        sellerId: sellerId,
        name: filters?.name || "",
        paginationRequestDTO: {
            pageNo: pagination.pageNo || 0,
            pageSize: pagination.pageSize || 10,
            sortBy: pagination.sortBy || "id",
            sortDir: pagination.sortDir || "ASC"
        }
    };

    const response = await httpClient.post("/v1/api/product/get-product-by-seller-id", body, {
        signal
    });

    return response?.data;
};

export const toggleProduct = async (productId, action) => {
    try {
        await httpClient.put(`/v1/api/product/update-enable/${productId}/${action}`);
        return {
            productId,
            action: action
        };
    } catch (error) {
        try {
            //swtich back to the original state
            await httpClient.put(`/v1/api/product/update-enable/${productId}/${!action}`);
            //and then try again
            await httpClient.put(`/v1/api/product/update-enable/${productId}/${action}`);
            return {
                productId,
                action: action
            };
        } catch (error) {
            console.log("error on toggling product", error);
            throw error;
        }
    }
};
